module.exports = __webpack_public_path__ + "img/Team-Wilde-Pracht-620.4280d304.jpg";